const analyticsCategory = __POSTHOG_ENABLED__
  ? {
      analytics: {
        enabled: false,
        readOnly: false,
      },
    }
  : {};

const consentDescription = __POSTHOG_ENABLED__
  ? 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. You can opt-out of each cookie category (except strictly necessary cookies) by clicking on the "Manage preferences" button.'
  : 'Hi, this website uses essential cookies to ensure its proper operation. No tracking cookies are set.';

const cookieUsageDescription = __POSTHOG_ENABLED__
  ? 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want (except strictly necessary cookies).'
  : 'We use cookies to ensure the basic functionalities of the website. Only strictly necessary cookies are set.';

const analyticsSection = __POSTHOG_ENABLED__
  ? [
      {
        title: 'Analytics and advertising cookies',
        description:
          'These allow us to recognise and count the number of visitors to our website, and see how visitors browse our website, so we can improve it where necessary. These also allow us to see what pages and links you have visited so we can provide more relevant ads. We may share this information with other organisations, such as Google and PostHog, for the same purpose.',
        linkedCategory: 'analytics',
      },
    ]
  : [];

export const pluginConfig = {
  guiOptions: {
    consentModal: {
      layout: 'box',
      position: 'bottom right',
    },
  },

  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    ...analyticsCategory,
  },

  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'We use cookies!',
          description: consentDescription,
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage preferences',
        },
        preferencesModal: {
          title: 'Cookie Settings',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          closeIconLabel: 'Close',
          sections: [
            {
              title: 'Cookie usage 📢',
              description: cookieUsageDescription,
            },
            {
              title: 'Strictly necessary cookies',
              description:
                'These cookies are essential for the proper functioning of our website. Without these cookies, the website would not work properly.',
              linkedCategory: 'necessary',
            },
            ...analyticsSection,
          ],
        },
      },
    },
  },
};
